/* eslint-disable func-style */
import { SxProps, Theme, alpha } from '@mui/material';

const colorTileActiveMiddle = (theme: Theme) => alpha(theme.palette.primary.light, 0.15);
const colorTileActiveMiddleHover = (theme: Theme) => alpha(theme.palette.primary.light, 0.25);
const colorTileHasActive = (theme: Theme) => alpha(theme.palette.primary.dark, 0.6);
const colorTileHasActiveHover = (theme: Theme) => alpha(theme.palette.primary.dark, 0.8);
const colorTileActiveMiddleSelecting = (theme: Theme) => alpha(theme.palette.primary.light, 0.05);

export const sxContainer: SxProps<Theme> = (theme) => ({
  mr: 2,
  display: 'inline-flex',
  position: 'relative',
  '.react-daterange-picker__calendar': {
    zIndex: theme.zIndex.modal,
  },
  '.react-daterange-picker__wrapper': {
    border: 'none',
    padding: '7.5px',
    borderRadius: '4px',
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    fontWeight: '400',
    fontSize: '1rem',
    lineHeight: '1.4375em',
    letterSpacing: '0.00938em',
  },
  '.react-daterange-picker__calendar-button': {
    padding: '0px',
  },
  '.react-daterange-picker__inputGroup__input': { outline: 'none' },
  '.react-calendar': {
    '.react-calendar__navigation': {
      marginTop: '16px',
    },
    '.react-calendar__year-view__months, .react-calendar__decade-view__years, .react-calendar__century-view__decades':
      {
        padding: '6px',
      },
    '& .react-calendar__navigation__arrow': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      backgroundColor: 'transparent',
      outline: '0',
      border: '0',
      margin: '0',
      cursor: 'pointer',
      userSelect: 'none',
      verticalAlign: 'middle',
      textDecoration: 'none',
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: '1.5rem',
      padding: '8px',
      borderRadius: '50%',
      overflow: 'visible',
      color: 'rgba(0, 0, 0, 0.54)',
      transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      height: '14px',
      width: '14px',
      boxSizing: 'content-box',
    },
    '& .react-calendar__navigation__arrow:disabled': {
      color: 'rgba(0, 0, 0, 0.28)',
      cursor: 'default',
    },
    '& .react-calendar__navigation__label': {
      fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
      fontWeight: '500',
      fontSize: '1rem',
      lineHeight: '1.5',
      letterSpacing: '0.00938em',
    },
    '.react-calendar__tile:enabled:hover > abbr, .react-calendar__tile:enabled:focus > abbr, .react-calendar__tile.react-calendar__decade-view__years__year:enabled:focus, .react-calendar__tile.react-calendar__decade-view__years__year:enabled:hover, .react-calendar__tile.react-calendar__century-view__decades__decade:enabled:hover, .react-calendar__tile.react-calendar__century-view__decades__decade:enabled:focus':
      {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    '.react-calendar__tile': {
      paddingTop: 0,
      paddingBottom: 0,
    },
    '.react-calendar__tile > abbr, .react-calendar__tile.react-calendar__decade-view__years__year, .react-calendar__tile.react-calendar__century-view__decades__decade':
      {
        color: 'rgba(0, 0, 0, 0.87)',
        padding: '4px',
        fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
        fontWeight: '400',
        fontSize: '0.75rem',
        lineHeight: '1.66',
        letterSpacing: '0.03333em',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        height: '36px',
      },
    '.react-calendar__tile.react-calendar__year-view__months__month > abbr, .react-calendar__tile.react-calendar__decade-view__years__year, .react-calendar__tile.react-calendar__century-view__decades__decade':
      {
        border: 'none',
        borderRadius: '18px',
        padding: '8px 12px',
      },
    '.react-calendar__tile.react-calendar__month-view__days__day > abbr': {
      width: '36px',
      borderRadius: '50%',

      margin: '0',
    },
    '.react-calendar__tile--rangeStart > abbr, .react-calendar__tile--rangeEnd > abbr': {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    '.react-calendar__tile--active': {
      background: colorTileActiveMiddle(theme),
    },
    '.react-calendar__tile--rangeStart': {
      background: `linear-gradient(97deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, ${colorTileActiveMiddle(
        theme,
      )} 50%)`,
    },
    '.react-calendar__tile--rangeEnd': {
      background: `linear-gradient(280deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, ${colorTileActiveMiddle(
        theme,
      )} 50%)`,
    },
    '.react-calendar__tile--active:enabled:hover > abbr, .react-calendar__tile--active:enabled:focus > abbr':
      {
        backgroundColor: colorTileActiveMiddleHover(theme),
      },
    '.react-calendar__tile--rangeStart:enabled:hover > abbr, .react-calendar__tile--rangeEnd:enabled:hover > abbr, .react-calendar__tile--active:enabled:focus > abbr, .react-calendar__tile--active.react-calendar__decade-view__years__year:enabled:focus':
      {
        backgroundColor: theme.palette.primary.dark,
      },
    '.react-calendar__tile--now > abbr': {
      border: `1px solid ${theme.palette.primary.main} `,
    },
    '.react-calendar__tile:disabled > abbr, .react-calendar__tile.react-calendar__decade-view__years__year:disabled, .react-calendar__tile.react-calendar__century-view__decades__decade:disabled':
      {
        color: 'rgba(0, 0, 0, 0.38)',
      },
    '.react-calendar__tile--hasActive > abbr, .react-calendar__tile--hasActive.react-calendar__decade-view__years__year, .react-calendar__tile--hasActive.react-calendar__century-view__decades__decade':
      {
        backgroundColor: colorTileHasActive(theme),
        color: theme.palette.primary.contrastText,
      },
    '.react-calendar__tile--hasActive:enabled:hover > abbr, .react-calendar__tile--hasActive:enabled:focus > abbr, .react-calendar__tile--hasActive.react-calendar__decade-view__years__year:enabled:hover, .react-calendar__tile--hasActive.react-calendar__century-view__decades__decade:enabled:hover':
      {
        backgroundColor: colorTileHasActiveHover(theme),
        color: theme.palette.primary.contrastText,
      },
    '.react-calendar__tile--rangeBothEnds, .react-calendar__tile--hoverEnd.react-calendar__tile--hoverStart.react-calendar__tile--rangeBothEnds:enabled:hover':
      {
        background: 'none',
      },
    '.react-calendar__tile--hover': {
      backgroundColor: colorTileActiveMiddleSelecting(theme),
    },
    '.react-calendar__tile--hoverStart': {
      background: `linear-gradient(97deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, ${colorTileActiveMiddleSelecting(
        theme,
      )} 50%)`,
    },
    '.react-calendar__tile--hoverEnd': {
      background: `linear-gradient(280deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, ${colorTileActiveMiddleSelecting(
        theme,
      )} 50%)`,
    },
    '.react-calendar__tile--hoverStart:enabled:hover > abbr, .react-calendar__tile--hoverEnd:enabled:hover > abbr':
      {
        background: alpha(theme.palette.primary.main, 0.6),
        color: theme.palette.primary.contrastText,
      },
  },
});

export const sxLabel: SxProps = {
  color: 'rgba(0, 0, 0, 0.6)',
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  fontWeight: '400',
  fontSize: '1rem',
  lineHeight: '1.4375em',
  letterSpacing: '0.00938em',
  padding: '0',
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 'calc(133% - 24px)',
  position: 'absolute',
  left: '0',
  top: '0',
  transform: 'translate(14px, -9px) scale(0.75)',
  transition:
    'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  zIndex: '1',
  pointerEvents: 'auto',
  userSelect: 'none',
};

export const sxFieldset: SxProps = {
  textAlign: 'left',
  position: 'absolute',
  bottom: '0',
  right: '0',
  top: '-5px',
  left: '0',
  margin: '0',
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: '4px',
  borderStyle: 'solid',
  borderWidth: '1px',
  overflow: 'hidden',
  minWidth: '0%',
  borderColor: 'rgba(0, 0, 0, 0.23)',
};

export const sxLegend: SxProps = {
  float: 'unset',
  overflow: 'hidden',
  display: 'block',
  width: 'auto',
  padding: '0',
  height: '11px',
  fontSize: '0.75em',
  visibility: 'hidden',
  maxWidth: '100%',
  transition: 'max-width 100ms cubic-bezier(0.0, 0, 0.2, 1) 50ms',
  whiteSpace: 'nowrap',
  '& > span': {
    paddingLeft: '5px',
    paddingRight: '5px',
    display: 'inline-block',
    opacity: '0',
    visibility: 'visible',
    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
    fontWeight: '400',
    lineHeight: '1.4375em',
    letterSpacing: '0.00938em',
  },
};
